<!--
 * @Description: In User Settings Edit
 * @Author: lic
 * @Date: 2019-07-23 09:55:47
 * @LastEditTime: 2019-09-06 14:21:47
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div id="activityList">
    <!--<div class="navi_bar">-->
      <!--<div class="navi_bar_item"-->
           <!--@click="exchangeNaviBar(0)">-->
        <!--<div :class="{'active':navbarActiveIndex == 0}">进行中</div>-->
      <!--</div>-->
      <!--<div class="navi_bar_item"-->
           <!--@click="exchangeNaviBar(1)">-->
        <!--<div :class="{'active':navbarActiveIndex == 1}">我参与的</div>-->
      <!--</div>-->
    <!--</div>-->
    <div class="activity_content">
      <!-- <v-scroll :on-refresh="onRefresh"
                :on-infinite="onInfinite"> -->
      <div class="scroll_inner">
        <div class="activity_item"
             v-for="(item, index) in activityList"
             :key="index"
             @click="navigateToActivityDetail(item)">
          <img class="banner_image"
               :src="item.popularizeImage"
               alt="">
          <img v-if="navbarActiveIndex == 0 || item.status == 'FORMAL_UNDERWAY'"
               class="item_flag"
               :src="picUrl.flagIng"
               alt="">
          <img v-else
               :src="picUrl.flagEnd"
               class="item_flag"
               alt="">
          <div class="item_detail">
            <div class="image_back"
                 v-if="item.readLimitDes && item.readLimitDes.length > 0"></div>
            <div class="image_back_text">{{item.readLimitDes}}</div>
            <div class="item_title">{{item.popularizeName}}</div>
            <p v-if="navbarActiveIndex == 0"
               class="item_msg">瓜分：<span>{{item.totalBonus}}</span> 元 最高奖励：<span>{{item.personalCap}}</span> 元</p>
            <p v-else
               class="item_msg">我的战力：<span>{{item.personBonus}}</span></p>
          </div>
        </div>
      </div>
      <!-- </v-scroll> -->
    </div>
    <div class="tab_bar">
      <div class="tab_bar_item">
        <img :src="picUrl.tabTaskSel"
             alt="">
        <span class="active">星任务</span>
      </div>
      <div class="tab_bar_item"
           @click="navigateToMine">
        <img :src="picUrl.tabMeDef"
             alt="">
        <span>我的星球</span>
      </div>
    </div>
  </div>
</template>

<script>
// import scroll from '@/components/scroll'
import { formatCurrency, floatMul } from '@/utils/index.js'
export default {
  name: 'activityList',
  data () {
    return {
      picUrl: {
        tabTaskDef: this.$store.state.ossLink + 'icon_task_def.png',
        tabTaskSel: this.$store.state.ossLink + 'icon_task_sel.png',
        tabMeDef: this.$store.state.ossLink + 'icon_me_def.png',
        tabMeSel: this.$store.state.ossLink + 'icon_me_sel.png',
        flagEnd: this.$store.state.ossLink + 'bg_end.png',
        flagIng: this.$store.state.ossLink + 'bg_ing.png'
      },
      navbarActiveIndex: 1,
      pageNo: 1, // 当前页
      pageSize: 10, // 一页显示多少条
      totalRow: 0, // 总共条数
      activityList: [], // 下拉更新数据存放数组
      dataList: {
        noFlag: false // 暂无更多数据显示
      }
    }
  },
  methods: {
    /**
     * 切换tabBar
     */
    exchangeNaviBar (val) {
      this.navbarActiveIndex = val
      this.getQueryList()
    },
    // getList () {
    //   let more = this.$el.querySelector('.load-more')
    //   more.style.display = 'none' // 隐藏加载条
    //   this.activityList = [1, 2, 3]
    // },
    // onRefresh (done) {
    //   this.pageNo = 1
    //   this.getList()
    //   done() // call done
    // },
    // onInfinite (done) {
    //   if (this.pageNo * this.pageSize < this.totalRow) {
    //     this.pageNo++
    //     this.getList()
    //   }
    //   done()
    // },
    /**
     * /h5/star/alliance2/star/guest/account/total/obtain/my/account
     * 获取openid
     */
    getOpenId () {
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/guest/account/total/obtain/my/account'
        })
        .then(res => {
          if (res.success) {
            localStorage.setItem('WECHAT_OPEN_ID', res.data.starGuestNo)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * 跳转到星客活动详情页面
     */
    navigateToActivityDetail (item) {
      localStorage.setItem('share_saleOrgType', 'STAR_GUEST')
      localStorage.setItem('share_saleOrgNo', localStorage.getItem('WECHAT_OPEN_ID'))
      localStorage.setItem('activityId', item.popularizeObjId)
      localStorage.setItem('share_clerkId', '')
      localStorage.setItem('STAR_ACTIVITY_SHARE_TITLE', item.shareTitle)
      localStorage.setItem('STAR_ACTIVITY_SHARE_TEXT', item.shareText)
      localStorage.setItem('STAR_ACTIVITY_SHARE_IMAGE', item.shareImage)
      this.$router.push(
        { path: '/activityShare', query: { popularizeNo: item.popularizeNo, popularizeId: item.popularizeId } })
    },
    /**
     * 星客联盟进行中的活动
     * /h5/star/task/popularize/list/by/mall
     * 星客联盟我参与的
     * /h5/star/task/my/join/activity
     */
    getQueryList () {
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: self.navbarActiveIndex === 1 ? '/h5/star/task/my/join/activity' : '/h5/star/task/popularize/list/by/mall'
        })
        .then(res => {
          if (res.success) {
            res.data.forEach(item => {
              item.totalBonus = formatCurrency(item.totalBonus)
              item.personalCap = formatCurrency(item.personalCap)
              item.personBonus = floatMul(item.personBonus, 100)
              return item
            })
            self.activityList = res.data
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    navigateToMine () {
      this.$router.push('/mine')
    },
    wxShare () {
      let self = this
      self.$fly
        .request({
          url: '/component/wechat/login/get/js/config/stat',
          params: {
            url: location.href.split('#')[0]
          }
        })
        .then(res => {
          if (res.success) {
            self.$wx.config({
              debug: false,
              appId: res.data.appId,
              timestamp: res.data.timestamp,
              nonceStr: res.data.nonceStr,
              signature: res.data.signature,
              jsApiList: [
                'hideAllNonBaseMenuItem',
                'showAllNonBaseMenuItem'
              ]
            })
            self.$wx.ready(function () {
              // 隐藏分享
              self.$wx.hideAllNonBaseMenuItem()
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  // components: {
  //   'v-scroll': scroll
  // },
  activated () {
    this.exchangeNaviBar(1)
    this.wxShare()
  },
  mounted () {
    this.getOpenId()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#activityList {
  width: 100%;
  height: 100vh;
  background: #f0f0f0;
}
.activity_content {
  position: fixed;
  top: 0;
  bottom: 100px;
  left: 0;
  width: 100%;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  .activity_item {
    margin: 20px;
    width: calc(100% - 40px);
    background-color: #ffffff;
    position: relative;
    .banner_image {
      width: 100%;
      border-radius: 8px 8px 0px 0px;
      display: block;
    }
    .item_flag {
      position: absolute;
      right: 16px;
      top: 0;
      width: 77px;
    }
    .item_detail {
      position: relative;
      .image_back {
        position: absolute;
        top: -60px;
        left: 0;
        width: 100%;
        height: 60px;
        background-color: #000000;
        opacity: 0.5;
      }
      .image_back_text {
        position: absolute;
        line-height: 60px;
        top: -60px;
        left: 0;
        width: 100%;
        text-align: center;
        color: #fff;
        height: 60px;
        font-size: 24px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .item_title {
        padding: 20px 17px 0 17px;
        width: calc(100% - 34px);
        font-size: 28px;
        text-align: left;
        color: #333333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .item_msg {
        padding: 4px 17px 18px 17px;
        width: calc(100% - 34px);
        text-align: left;
        font-size: 26px;
        color: #999999;
      }
      .item_msg span {
        color: #ff000c;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/activity/list.vue